(($, Drupal) => {
  const initFeatureWithText = (el) => {
    const $this = $(el);
    const toggler = $this.find('[data-action="toggle-tooltip"]');
    const target = $this.find('[data-target="feature-tooltip"]');
    const targetWidth = target.outerWidth();
    const parentWidth = $this.outerWidth();
    const padding = 12;
    const paddingLg = 25;
    let parentOffsetLeft = $this.offset().left;
    let vw = $(window).width();

    const setWidth = (windowWidth, left) => {
      const minOffsetLeft = targetWidth - parentWidth - paddingLg;

      if (vw >= 768) {
        target.css({
          width: '',
          transform: '',
        });

        if (parentOffsetLeft + targetWidth * 0.5 > vw) {
          target.css({ transform: `translateX(-${minOffsetLeft}px)` });
        } else {
          const translate = targetWidth / 2 - parentWidth / 2;
          target.css({ transform: `translateX(-${translate}px)` });
        }
      } else {
        const tooltipWidth = `${windowWidth - padding * 4}px`;
        target.css({
          width: tooltipWidth,
          transform: `translateX(-${left - padding * 2}px)`,
        });
      }
    };

    if (toggler.length === 0 || target.length === 0) {
      return;
    }

    setWidth(vw, parentOffsetLeft);

    function handleUsingEscKey(e) {
      const key = e.key || e.keyCode;
      if (key === 27 || key === 'Escape') {
        target.hide();
      }
    }

    $this.on('mouseover', () => {
      target.show();
    });

    $this.on('mouseleave', () => {
      target.hide();

      $this.off('keydown', (e) => {
        handleUsingEscKey(e);
      });
    });

    toggler.on('click', () => {
      target.show();

      $this.on('keydown', (e) => {
        handleUsingEscKey(e);
      });
    });

    $(window).on('resize', () => {
      vw = $(window).width();
      parentOffsetLeft = $this.offset().left;

      setWidth(vw, parentOffsetLeft);
    });
  };

  Drupal.behaviors.mstFeatureWithHelptext = {
    attach: (context) => {
      $('.feature-with-helptext', context).each((index, element) => initFeatureWithText(element));
    },
  };
})(jQuery, Drupal);
